<template>
  <div>
    <!-- shield-check -->
    <svg
      v-if="word.status == 'classified'"
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5 text-gray-400"
      :class="css"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
      />
    </svg>

    <!-- inbox-alt -->
    <svg
      v-if="word.status == 'new'"
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5"
      :class="css"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
      />
    </svg>

    <!-- chat-alt -->
    <svg
      v-if="word.status == 'classifiable'"
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5"
      :class="css"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    word: {
      required: true,
      default: Object,
    },
    css: {
      required: false,
      default: String
    }
  },
};
</script>